export default ({ request }) => ({
  masterSamplePropertiesListApi(data = {}) {
    return request({
      url: '/master/sample/properties/list',
      method: 'post',
      data,
    })
  },
  masterSamplePropertiesDetailApi(data = {}) {
    return request({
      url: '/master/sample/properties/detail',
      method: 'post',
      data,
    })
  },
  masterSamplePropertiesSaveApi(data = {}) {
    return request({
      url: '/master/sample/properties/save',
      method: 'post',
      data,
    })
  },
  masterSamplePropertiesDelApi(data = {}) {
    return request({
      url: '/master/sample/properties/del',
      method: 'post',
      data,
    })
  },
  masterSamplePropertiesAuditApi(data = {}) {
    return request({
      url: '/master/sample/properties/audit',
      method: 'post',
      data,
    })
  },
})
